export { default } from './ShelfHeader';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfHeader/index.js